import React, { useState } from 'react'
import { Menu, MenuItem, MenuList, Paper } from '@mui/material'
import { MoreButton } from 'common/Button/MoreButton'
import TextColorFontBody from 'common/Typography/TextColorFontBody'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'
import { AllCustomerPayments } from 'types/api/faber/payment.type'

import FaberFinanceUpdateDialog from './FaberFinanceUpdateDialog'

const FaberFinanceActionMenu = ({
  paymentRow,
  handleMarkAsPaid,
  updateRow
}: DemoFaberFinanceActionMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const [demoDialog, setDemoDialogOpen] = useState(false)

  const handleDemoDialogOpen = () => {
    setDemoDialogOpen(true)
  }

  const handleDemoDialogClose = () => {
    setDemoDialogOpen(false)
  }

  return (
    <>
      <MoreButton onClick={handleMenuOpen} />
      <Paper>
        <MenuList dense>
          <Menu
            id='action-menu'
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button'
            }}
          >
            <MenuItem onClick={() => handleDemoDialogOpen()}>
              <TextColorFontBody
                sx={{
                  color: circlesOrbitColorPalette.neutrals[600],
                  fontSize: '12px'
                }}
              >
                Update
              </TextColorFontBody>
            </MenuItem>
            <FaberFinanceUpdateDialog
              handlePaymentStatusDialogClose={handleDemoDialogClose}
              paymentStatusDialog={demoDialog}
              handleMenuClose={handleMenuClose}
              paymentRow={paymentRow}
              handleMarkAsPaid={handleMarkAsPaid}
              handleSubmit={updateRow}
            />
          </Menu>
        </MenuList>
      </Paper>
    </>
  )
}

interface DemoFaberFinanceActionMenuProps {
  paymentRow: AllCustomerPayments
  handleMarkAsPaid: (sin: string) => void
  updateRow
}

export default FaberFinanceActionMenu
